export const getLocale = (language: string, _country?: string | undefined): string => {
  if (language === 'ar') {
    return 'ar-AE';
  }
  return 'en-US';
};
